import React, { useEffect, useState } from 'react';
import UserProfile from './Features/UserProfile';
import Products from './Features/Products';
import { Link } from 'react-router-dom';

export default function ProfileComponents() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Check if there is a token in localStorage or any other authentication logic
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token);
  }, []);

  return (
    <>
      {isLoggedIn ? (
        <div className="md:flex">
          <UserProfile />
          <Products />
        </div>
      ) : (
        <div className="text-center mt-24">
          <p className="text-xl font-semibold mb-4">
            You must log in to view details.
          </p>
          <Link to="/login" className="px-4 py-2 bg-amber-500 text-white rounded-md">
            Log In
          </Link>
        </div>
      )}
    </>
  );
}
